import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import renderHTML from 'react-render-html';

const styles = theme => ({
  heroContent: {
    margin: '0 auto',
    padding: `${theme.spacing(1) * 8}px 0 ${theme.spacing(1) * 6}px`
  },
  getStarted: {
    marginTop: 20
  }
});

class HeroContent extends Component {
  render() {
   const  { classes,
            title,
            description
          } = this.props;

    return (
      <div className={classes.heroContent}>
        <Typography variant="h2" align="center" color="textPrimary" gutterBottom>
          { title }
        </Typography>
        <Typography variant="h6" align="center" color="textSecondary" component="p">
          { renderHTML(description) }
        </Typography>
        <Typography variant="h4" align="center" color="textPrimary" component="p" className={classes.getStarted}>
          Select a Pack to get Started
        </Typography>
      </div>
    )
  }
}

export default withStyles(styles)(HeroContent)
